export default __webpack_public_path__ + "static/media/urticaria.86a6f678.pdf";